module.exports = "//static.hsappstatic.net/LoginUI/static-1.15632/img/donut_mobile.svg"